<template>
  <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
  ></v-progress-circular>
  <div v-else :class="{ 'blur--content': isUploading }">
    <h1 class="text-center mt-3">Survey</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <v-snackbar
          v-model="snackbar"
          :timeout="2000"
          :color="snackbarColor"
          top
          class="snackbar-center"
      >
        {{ snackbarMessage }}
      </v-snackbar>
      <div class="row">
        <div class="col">
          <BrandDropdown
              v-model="form.brandSelected"
              @setBrand="setBrand"
              @setBrands="setBrands"
              :class="{
              'input--error': isSubmit && error.errorBrandCode,
            }"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrandCode" class="text-error">
            {{ error.errorBrandCode.message }}
          </div>
        </div>
        <div class="col">
          <label for="name"> Name</label>
          <input
              id="name"
              type="text"
              v-model="form.name"
              class="form-control"
              :class="{
              'input--error': isSubmit && error.errorName,
            }"
          />
          <div v-if="isSubmit && error.errorName" class="text-error">
            {{ error.errorName.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row">
            <input
                class="form-check-input mr-2"
                id="isActive"
                type="checkbox"
                v-model="form.status"
                :class="{
                'input--error': isSubmit && error.errorStatus,
              }"
            />
            <label class="form-check-label" for="isActive"> Active </label>
          </div>
          <div v-if="isSubmit && error.errorStatus" class="text-error">
            {{ error.errorStatus.message }}
          </div>
        </div>
      </div>
      <template>
        <v-container>
          <v-tabs
              v-model="tab"
              background-color="white"
              show-arrows
              class="custom-tabs"
              slider-color="transparent"
          >
            <v-tab
                v-for="(tabName, index) in ['รายละเอียด', 'สร้าง QR Code', 'อัปโหลด responses']"
                :key="index"
                :disabled="index > 0 && !id"
                :class="{ 'active-tab': tab === index }"
            >
              {{ tabName }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- Tab 1 Content -->
            <v-tab-item>
              <v-card :dark="false" :light="false">
                <v-card-text class="black--text">
                  <div>
                    <div class="row">
                      <div class="col">
                        <label for="startDate" required>Start date</label>
                        <date-picker
                            id="startDate"
                            v-bind="$attrs"
                            v-model="form.startDate"
                            format="D MMMM yyyy"
                            lang="en"
                            :value="form.startDate"
                            @change="
              changeStartDate($event);
              form.startDate = $event;
            "
                            style="margin-top: -0.6rem"
                            :class="{
              'input--error': isSubmit && error.errorStartDate,
            }"
                        />
                        <div v-if="isSubmit && error.errorStartDate" class="text-error">
                          {{ error.errorStartDate.message }}
                        </div>
                      </div>
                      <div class="col">
                        <label for="endDate" required>End date</label>
                        <date-picker
                            id="endDate"
                            v-bind="$attrs"
                            v-model="form.endDate"
                            format="D MMMM yyyy"
                            lang="en"
                            :value="form.endDate"
                            :minDate="form.startDate"
                            @change="form.endDate = $event"
                            style="margin-top: -0.6rem"
                            :class="{
              'input--error': isSubmit && error.errorEndDate,
            }"
                        />
                        <div v-if="isSubmit && error.errorEndDate" class="text-error">
                          {{ error.errorEndDate.message }}
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="id">
                      <div class="col">
                        <div>Link to survey on Beauty Connect</div>
                        <div class="accessLink d-flex gap-2">
                          <div class="pt-1">
                            {{ accessLink }}
                          </div>
                          <button @click="copyLink">
                            <font-awesome-icon :icon="['fas', 'copy']" id="copySurveyLink"/>
                          </button>
                        </div>
                        <b-tooltip
                            target="copySurveyLink"
                            triggers="hover"
                            placement="bottom"
                            variant="dark"
                        >{{ copyText }}
                        </b-tooltip>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <label for="surveyUrl"> Survey URL (from survey monkey)</label>
                        <input
                            id="surveyUrl"
                            type="text"
                            v-model="form.surveyUrl"
                            class="form-control"
                            :class="{
              'input--error': isSubmit && error.errorSurveyUrl,
            }"
                        />
                        <div v-if="isSubmit && error.errorSurveyUrl" class="text-error">
                          {{ error.errorSurveyUrl.message }}
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <label for="pageTitleTh">Page title TH</label>
                        <input
                            id="pageTitleTh"
                            type="text"
                            v-model="form.pageTitleTh"
                            maxlength="1000"
                            class="form-control"
                        />
                      </div>

                      <div class="col">
                        <label for="pageTitleEn">Page title EN</label>
                        <input
                            id="pageTitleEn"
                            type="text"
                            v-model="form.pageTitleEn"
                            maxlength="1000"
                            class="form-control"
                        />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <label for="detailTh">Detail TH</label>
                        <div>
                          <CkEditor
                              id="detailTh"
                              :value="form.detailTh"
                              :isTh="true"
                              @setContent="setContentTh"
                          ></CkEditor>
                          <div v-if="isSubmit && error.errorDetailTh" class="text-error">
                            {{ error.errorDetailTh.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <label for="detailEn">Detail En</label>
                        <div>
                          <CkEditor
                              id="detailEn"
                              :value="form.detailEn"
                              :isTh="false"
                              @setContent="setContentEn"
                          ></CkEditor>
                          <div v-if="isSubmit && error.errorDetailEn" class="text-error">
                            {{ error.errorDetailEn.message }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-4">
                      <div class="col">
                        <label for="buttonCaptionTh">
                          Button caption TH
                        </label>

                        <input
                            id="buttonCaptionTh"
                            type="text"
                            v-model="form.buttonCaptionTh"
                            maxlength="500"
                            class="form-control"
                        />
                      </div>

                      <div class="col">
                        <label for="buttonCaptionEn">
                          Button caption EN
                        </label>

                        <input
                            id="buttonCaptionEn"
                            type="text"
                            v-model="form.buttonCaptionEn"
                            maxlength="500"
                            class="form-control"
                        />
                      </div>
                    </div>

                    <div class="d-flex justify-content-end mt-5">
                      <router-link
                          :to="{ name: 'Survey' }"
                          class="btn btn-outline-secondary btn-back-to-list ml-10"
                      >Back
                      </router-link
                      >
                      <button class="btn btn-outline-primary ml-5" @click="goToReport">
                        Report
                      </button>
                      <button class="btn btn-outline-success ml-5" @click="onSubmit">
                        Save
                      </button>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 2 Content -->
            <v-tab-item v-if="id">
              <v-card flat>
                <v-card-text class="black--text">
                  <v-progress-circular
                      v-if="isUploading && id"
                      :size="50"
                      :width="5"
                      color="primary"
                      class="upload-loading"
                      indeterminate
                  ></v-progress-circular>
                  <div v-else-if="!isUploading && id">
                    <div class="row">
                      <div class="col">
                        <label for="importedQrCodeFile">Import data</label>
                        <div class="">
                          <div class="row">
                            <div class="col-5">
                              <input
                                  id="importedQrCodeFile"
                                  type="file"
                                  class="form-control"
                                  ref="importSurveyDataFile"
                                  @change="changeSurveyDataFile"
                                  :disabled="isFileLoading"
                                  :class="{
                                    'input--error': isSubmit && error.errorSurveyResultPath,
                                  }"
                              />
                            </div>

                            <div class="col-3 d-flex align-items-center">
                              <FileLoading v-if="isFileLoading"/>
                              <button
                                  v-else
                                  class="btn btn-outline-primary w-100"
                                  @click="onUploadQrCodeFile"
                              >
                                Upload and get QR codes
                              </button>
                            </div>

                          </div>

                          <!-- Error message -->
                          <div
                              v-if="isSubmit && error.errorExcelSurveyResultPath"
                              class="text-error mt-1"
                          >
                            {{ error.errorExcelSurveyResultPath.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end mt-5">
                      <router-link
                          :to="{ name: 'Survey' }"
                          class="btn btn-outline-secondary btn-back-to-list ml-10"
                      >Back
                      </router-link
                      >
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 3 Content -->
            <v-tab-item v-if="id">
              <v-card flat>
                <v-card-text class="black--text">
                  <v-progress-circular
                      v-if="isUploading && id"
                      :size="50"
                      :width="5"
                      color="primary"
                      class="upload-loading"
                      indeterminate
                  ></v-progress-circular>
                  <div v-else-if="!isUploading && id">
                    <div class="row">
                      <div class="col">
                        <label for="importedFile">Import result</label>
                        <div class="pt-2">
                          <div class="d-flex justify-content-start">
                            <input
                                id="importedFile"
                                type="file"
                                class="form-control w-75"
                                ref="importSurveyFile"
                                @change="changeSurveyFile"
                                :disabled="isFileLoading"
                                :class="{
                                  'input--error': isSubmit && error.errorSurveyResultPath,
                                }"
                            />
                            <FileLoading extra-class="ml-5" v-if="isFileLoading"/>
                            <button
                                v-else
                                class="btn btn-outline-primary ml-5"
                                @click="onUploadFile"
                            >
                              Upload
                            </button>
                          </div>
                          <div
                              v-if="isSubmit && error.errorSurveyResultPath"
                              class="text-error"
                          >
                            {{ error.errorSurveyResultPath.message }}
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div>Total result</div>
                        <p class="pt-4">{{ form.totalResult }}</p>
                      </div>
                    </div>
                    <div>
                      <a
                          v-if="form.linkResult"
                          href="#"
                          target="_blank"
                          @click.prevent="downloadLatestResult"
                      >
                        Download latest result
                      </a>
                    </div>
                    <div class="d-flex justify-content-end mt-5">
                      <router-link
                          :to="{ name: 'Survey' }"
                          class="btn btn-outline-secondary btn-back-to-list ml-10"
                      >Back
                      </router-link
                      >
                      <button class="btn btn-outline-primary ml-5" @click="goToReport">
                        Report
                      </button>
                        <button
                            class="btn btn-outline-danger ml-5"
                            @click="deleteResult"
                        >
                          Delete Result
                        </button>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </template>

      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3>{{ message }}</h3>
          <div class="row text-center">
            <div v-if="showSuccess && id" class="col-12">
              <button class="btn-back" @click="setDefault">ตกลง</button>
            </div>
            <div v-if="showSuccess" class="col-12">
              <button
                  class="btn-back"
                  @click="() => $router.push({ name: 'Survey' })"
              >
                กลับสู่หน้าหลัก
              </button>
            </div>
          </div>
          <div v-if="!showSuccess" class="row text-center">
            <div class="col">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </div>
      </v-dialog>

      <v-dialog v-model="isShowConfirmDialog" width="500" persistent>
        <div class="confirm-dialog">
          <p>
            [Caution] The existing survey results will be replaced
            with result in the new upload file! <br/>
            Do you want to continue?
          </p>
          <div class="text-center">
            <button class="btn-back mr-5" @click="hideConfirmDialog">ปิด</button>
            <button class="btn-back" @click="confirmUpload">ใช่</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import DatePicker from "components/Datepicker/Datepicker.vue";
import CkEditor from "components/CkEditor/CkEditor.vue";
import FileLoading from "components/Loading/FileLoading.vue";
import SurveyService from "services/api/survey.service";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import ErrorFields from "@/views/Survey/errorFields";
import moment from "moment/moment";

export default {
  components: {
    FileLoading,
    CkEditor,
    DatePicker,
    BrandDropdown,
  },

  data() {
    return {
      id: this.$route.query.id,
      frontendHost: process.env.VUE_APP_HOST_FRONTEND,
      accessLink: null,
      copyText: "copy",
      message: null,
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      isFileLoading: false,
      isUploading: false,
      surveyResultPath : null,
      processId: null,
      isShowConfirmDialog: false,
      isDelete: false,
      form: {
        brandSelected: null,
        brandCodeId: null,
        name: null,
        startDate: null,
        endDate: null,
        surveyUrl: null,
        detailTh: null,
        detailEn: null,
        totalResult: 0,
        linkResult: null,
        pageTitleTh: null,
        pageTitleEn: null,
        buttonCaptionTh: null,
        buttonCaptionEn: null,
      },

      error: {
        ...ErrorFields,
      },
      tab: 0,
      filePath: null,
      bconFrontendUrl: null,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
    };
  },
  async mounted() {
    if (this.id) {
      this.isLoading = true;
      await this.getSurveyDetail(this.id);
      this.accessLink = this.bconFrontendUrl;
    }
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.resetErrorText();
      const form = this.form;
      const body = {
        brandCode: form.brandSelected?.id ?? form.brandCodeId ?? null,
        name: form.name,
        status: form.status ? "ACTIVE" : "INACTIVE",
        startDate: moment(form.startDate).format("DD/MM/YYYY"),
        endDate: moment(form.endDate).format("DD/MM/YYYY"),
        surveyUrl: form.surveyUrl,
        detailTh: form.detailTh,
        detailEn: form.detailEn,
        pageTitleTh: form.pageTitleTh,
        pageTitleEn: form.pageTitleEn,
        buttonCaptionTh: form.buttonCaptionTh,
        buttonCaptionEn: form.buttonCaptionEn,
      };
      if (this.id) {
        this.updateExistingSurvey(body);
      } else {
        this.createNewSurvey(body);
      }
    },
    async createNewSurvey(body) {
      await SurveyService.createSurvey(body)
          .then((res) => {
            this.createOrUpdateSuccess(res);
          })
          .catch((err) => {
            this.createOrUpdateFailure(err);
          });
    },
    async updateExistingSurvey(body) {
      await SurveyService.updateSurvey(body, this.id)
          .then((res) => {
            this.createOrUpdateSuccess(res);
          })
          .catch((err) => {
            this.createOrUpdateFailure(err);
          });
    },
    createOrUpdateSuccess(res) {
      this.isLoading = false;
      const data = res.data;
      this.id = data.id;
      this.showDialog = true;
      this.showSuccess = true;
      this.message = data.message ? data.message : "Save Survey success"
      this.getSurveyDetail(this.id);
    },
    createOrUpdateFailure(err) {
      this.isLoading = false;
      this.isUploading = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
        return;
      }
      if (errorData.message) {
        this.showDialog = true;
        this.message = errorData.message;
      }
    },
    async getSurveyDetail() {
      await SurveyService.getDetailSurvey(this.id)
          .then((res) => {
            this.isLoading = false;
            this.isUploading = false;
            const data = res.data.data;
            const form = this.form;
            form.brandCodeId = data.brandCode;
            this.setBrands(this.brands || []);
            form.name = data.name;
            form.status = data.status;
            form.startDate = data.startDate;
            form.endDate = data.endDate;
            form.surveyUrl = data.surveyUrl;
            form.detailTh = data.detailTh;
            form.detailEn = data.detailEn;
            form.totalResult = data.totalResult || 0;
            form.linkResult = data.linkResult;
            this.bconFrontendUrl = data.bconFrontendUrl;
            form.pageTitleTh = data.pageTitleTh;
            form.pageTitleEn = data.pageTitleEn;
            form.buttonCaptionTh = data.buttonCaptionTh;
            form.buttonCaptionEn = data.buttonCaptionEn;

            this.accessLink = data.bconFrontendUrl;
            this.copyText = "copy";

          })
          .catch((err) => {
            this.createOrUpdateFailure(err);
          });
    },
    changeSurveyFile() {
      const importFile = this.$refs.importSurveyFile.files[0];
      this.getPresignURL(importFile);
    },
    async getPresignURL(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("survey", file)
          .then((res) => {
            const data = res.data;
            this.surveyResultPath = data.key;
            this.updatePhotoToS3(data.presignedUrl, file);
          })
          .catch((err) => {
            console.log("Error: ", err.response);
          });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isFileLoading = false;
    },
    onUploadFile() {
      this.showConfirmDialog();
    },
    async confirmUpload() {
      this.isUploading = true;
      this.isSubmit = true;
      this.isDelete = false;
      this.isShowConfirmDialog = false;
      this.resetErrorText();
      const body = {
        surveyResultPath: this.surveyResultPath,
      };
      this.surveyResultPath = null;
      await SurveyService.uploadSurveyResult(body, this.id)
          .then((res) => {
            const data = res.data;
            this.processId = data.processId;
            this.getResultInterval = setInterval(() => {
              this.getResult();
            }, 10000);
          })
          .catch((err) => {
            this.createOrUpdateFailure(err);
          });
    },
    async deleteResult() {
      this.isUploading = true;
      this.isDelete = true;
      await SurveyService.deleteSurveyResult(this.id)
          .then((res) => {
            const data = res.data;
            this.processId = data.processId;
            this.getResultInterval = setInterval(() => {
              this.getResult();
            }, 10000);
          })
          .catch((err) => {
            this.createOrUpdateFailure(err);
          });
    },
    async getResult() {
      const param = {
        process: this.processId,
      };
      await SurveyService.getSurveyResult(param, this.id)
          .then(async (res) => {
            const data = res.data;
            if (data.processStatus.toUpperCase() === "EXECUTED") {
              this.clearTimeInterval();
              this.isUploading = false;
              this.form.totalResult = data.totalResult || 0;
              this.form.linkResult = data.linkResult;
              this.message = data.message;
              if (!data.message) {
                this.message = this.isDelete
                    ? "Successfully deleted the survey results"
                    : "Successfully uploaded file";
              }
              this.showDialog = true;
            }
          })
          .catch((err) => {
            this.clearTimeInterval();
            this.createOrUpdateFailure(err);
          });
    },
    clearTimeInterval() {
      clearInterval(this.getResultInterval);
    },
    showConfirmDialog() {
      this.isShowConfirmDialog = true;
    },
    hideConfirmDialog() {
      this.isShowConfirmDialog = false;
    },
    downloadLatestResult() {
      try {
        window.open(this.form.linkResult);
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
      this.$router.push({
        name: "DetailSurvey",
        query: { id: this.id },
      });
    },
    changeStartDate(val) {
      if (val > this.form.endDate) {
        this.form.endDate = null;
      }
    },
    setBrand(brand) {
      this.form.brandSelected = brand || null;
      this.form.brandCodeId   = brand?.id ?? null;
      if (this.id) this.accessLink = this.bconFrontendUrl;
    },
    setBrands(brands) {
      this.brands = brands || [];
      if (this.form.brandCodeId && !this.form.brandSelected) {
        this.form.brandSelected = this.brands.find(
            (b) => b.id === this.form.brandCodeId
        ) || null;
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.accessLink);
      this.copyText = "copied!";
    },
    setContentTh(content) {
      this.form.detailTh = content || "";
    },
    setContentEn(content) {
      this.form.detailEn = content || "";
    },
    setErrorText(errors) {
      this.error.errorBrandCode = errors.find(
          (e) => e.fieldName === "brandCode"
      );
      this.error.errorName = errors.find((e) => e.fieldName === "name");
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorStartDate = errors.find(
          (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorSurveyUrl = errors.find(
          (e) => e.fieldName === "surveyUrl"
      );
      this.error.errorDetailTh = errors.find((e) => e.fieldName === "detailTh");
      this.error.errorDetailEn = errors.find((e) => e.fieldName === "detailEn");
      this.error.errorSurveyResultPath = errors.find(
          (e) => e.fieldName === "surveyResultPath"
      );
      this.error.errorExcelSurveyResultPath = errors.find(
          (e) => e.fieldName === "filePath"
      );
    },
    resetErrorText() {
      this.error = {
        ...ErrorFields,
      };
    },
    changeSurveyDataFile() {
      const importFile = this.$refs.importSurveyDataFile.files[0];
      this.getPresignURLForQrCode(importFile);
    },

    async getPresignURLForQrCode(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("survey", file)
          .then((res) => {
            const data = res.data;
            this.filePath = data.key;
            this.updatePhotoToS3(data.presignedUrl, file);
          })
          .catch((err) => {
            console.log("Error: ", err.response);
          });
    },

    async onUploadQrCodeFile() {
      this.isSubmit = true;
      this.resetErrorText();

      if (!this.filePath) {
        this.error.errorExcelSurveyResultPath = { message: "Please select a file" };
        return;
      }

      try {
        this.isUploading = true;
        const body = { filePath: this.filePath };
        const res = await SurveyService.uploadExcelSurveyResult(body, this.id);

        const data = res.data;
        if (data.errors?.length > 0) {
          this.setErrorText(data.errors);
          this.isUploading = false;
          return;
        }

        this.message = data.message || "QR code file uploaded successfully";
        if (data.downloadLink) {
          window.open(data.downloadLink, "_blank");
        }
        this.snackbarMessage =  this.message;
        this.snackbarColor = "success";
        this.snackbar = true
      } catch (err) {
        const errorData = err.response?.data;
        if (errorData.errors?.length > 0) {
          this.setErrorText(errorData.errors);
          return;
        }
        if (errorData.message) {
          this.snackbarMessage =  errorData.message;
          this.snackbarColor = "error";
          this.snackbar = true
        }
      } finally {
        this.isUploading = false;
      }
    },
    goToReport() {
      const brandCode = this.form?.brandSelected?.id ?? this.brandSelected?.id ?? null;
      const surveyId  = this.id ?? this.surveySelected?.id ?? null;

      this.$router.push({
        name: 'SurveyReport',
        query: { brandCode, surveyId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.accessLink {
  font-size: 14px;
  font-weight: bold;
}

.btn-back-to-list {
  color: #333;

  .btn-back-to-list:hover {
    color: white;
  }
}

.label-title {
  font-weight: 900;
}

.upload-loading {
  left: 50%;
}

.blur--content {
  filter: blur(2px);
  pointer-events: none;
}

.confirm-dialog {
  background: #fff;
  padding: 2rem 2rem;
  height: 300px;

  p {
    font-size: 20px;
    padding-bottom: 2rem;
    text-align: center;
    font-weight: bold;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}

.custom-tabs {
  border-bottom: 1px solid black;
}

.v-tab {
  color: black !important;
  text-transform: none;
  transition: background-color 0.3s;
}

.active-tab {
  background-color: #e0e0e0;
  font-weight: bold;
}

.snackbar-center{
  max-width: 400px !important;
  left: 45% !important;
  color: black ;
  text-align: center;
}
</style>
